import { Box, BoxProps } from '@chakra-ui/react'

export type PillProps = BoxProps & {
  variant?: 'dark' | 'neutral' | 'turquoise'
  size?: 'sm' | 'md'
}

const variants = {
  dark: {
    bg: 'presets.neutral.100',
    color: 'presets.neutral.0',
  },
  neutral: {
    bg: 'presets.neutral.10',
    color: 'presets.neutral.80',
  },
  turquoise: {
    bg: 'presets.turquoise.60',
    color: 'presets.neutral.0',
  },
}

const sizes = {
  sm: {
    fontSize: '12px',
    fontWeight: 600,
    px: '8px',
    py: '4px',
    lineHeight: 1.5,
  },
  md: {
    fontSize: '14px',
    fontWeight: 700,
    px: '12px',
    py: '6px',
    lineHeight: 1.5,
  },
}

const getCircleSize = (
  fontSize: string | number,
  lineHeight: string | number,
  py: string | number,
) => {
  return (
    parseFloat(String(fontSize)) * parseFloat(String(lineHeight)) +
    parseFloat(String(py)) * 2
  )
}

export const Pill = ({
  variant = 'neutral',
  size = 'md',
  children,
  ...props
}: PillProps) => {
  const isCircle =
    (typeof children === 'string' || typeof children === 'number') &&
    String(children).length === 1

  const circleSize = isCircle
    ? getCircleSize(
        sizes[size].fontSize,
        sizes[size].lineHeight,
        sizes[size].py,
      )
    : undefined

  return (
    <Box
      w={circleSize}
      h={circleSize}
      rounded="full"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      {...sizes[size]}
      px={isCircle ? '0' : sizes[size].px}
      py={isCircle ? '0' : sizes[size].py}
      {...variants[variant]}
      {...props}
    >
      {children}
    </Box>
  )
}
